import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "questionnaire_body"
};
const _hoisted_2 = {
  class: "navbat"
};
const _hoisted_3 = {
  class: "form"
};
const _hoisted_4 = {
  class: "tab"
};
const _hoisted_5 = {
  key: 0,
  class: "form_dom"
};
const _hoisted_6 = {
  class: "dom_assembly bodr_b"
};
const _hoisted_7 = {
  key: 1,
  class: "form_dom"
};
const _hoisted_8 = {
  class: "dom_assembly"
};
const _hoisted_9 = {
  key: 2,
  class: "form_dom"
};
const _hoisted_10 = {
  class: "dom_assembly bodr_b"
};
const _hoisted_11 = {
  key: 0,
  style: {
    "font-size": "40px",
    "padding": "0 20px"
  }
};
const _hoisted_12 = {
  key: 3,
  class: "form_dom"
};
const _hoisted_13 = {
  class: "dom_assembly bodr_b",
  style: {
    "justify-content": "space-between",
    "display": "flex"
  }
};
const _hoisted_14 = {
  key: 4,
  class: "form_dom"
};
const _hoisted_15 = {
  class: "dom_assembly bodr_b"
};
const _hoisted_16 = {
  key: 5,
  class: "form_dom"
};
const _hoisted_17 = {
  class: "dom_assembly Diseases_assembly"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
  key: 0,
  class: "option_more_form",
  style: {
    "border": "none"
  }
};
const _hoisted_20 = {
  class: "bodr_b"
};
const _hoisted_21 = {
  class: "dom_assembly"
};
const _hoisted_22 = {
  class: "form"
};
const _hoisted_23 = {
  class: "tab"
};
const _hoisted_24 = {
  key: 0,
  class: "nr_tip"
};
const _hoisted_25 = {
  key: 1,
  class: "form_dom"
};
const _hoisted_26 = {
  class: "dom_assembly bodr_b"
};
const _hoisted_27 = {
  key: 2,
  class: "form_dom"
};
const _hoisted_28 = {
  class: "dom_assembly bodr_b"
};
const _hoisted_29 = {
  key: 3,
  class: "form_dom"
};
const _hoisted_30 = {
  class: "dom_assembly bodr_b"
};
const _hoisted_31 = {
  key: 4,
  class: "form_dom"
};
const _hoisted_32 = {
  class: "dom_assembly bodr_b"
};
const _hoisted_33 = {
  key: 5,
  class: "form_dom"
};
const _hoisted_34 = {
  class: "dom_assembly bodr_b"
};
const _hoisted_35 = {
  key: 6,
  class: "form_dom"
};
const _hoisted_36 = {
  class: "dom_assembly bodr_b"
};
const _hoisted_37 = {
  key: 7,
  class: "form_dom"
};
const _hoisted_38 = {
  class: "dom_assembly dom_assembly_more"
};
const _hoisted_39 = {
  class: "option_more"
};
const _hoisted_40 = {
  key: 0,
  src: "https://www.mimodental.com/assets/imgData/img/questionnaire/t_jt.png",
  style: {
    "margin-top": "20px"
  },
  alt: ""
};
const _hoisted_41 = {
  key: 0,
  class: "option_more_form"
};
const _hoisted_42 = {
  class: "bodr_b"
};
const _hoisted_43 = {
  class: "dom_assembly"
};
const _hoisted_44 = {
  class: "bodr_b"
};
const _hoisted_45 = {
  class: "dom_assembly"
};
const _hoisted_46 = {
  key: 8,
  class: "form_dom"
};
const _hoisted_47 = {
  class: "dom_assembly dom_assembly_more"
};
const _hoisted_48 = {
  class: "option_more"
};
const _hoisted_49 = {
  key: 0,
  src: "https://www.mimodental.com/assets/imgData/img/questionnaire/t_jt.png",
  style: {
    "margin-top": "20px"
  },
  alt: ""
};
const _hoisted_50 = {
  key: 0,
  class: "option_more_form"
};
const _hoisted_51 = {
  class: "bodr_b"
};
const _hoisted_52 = {
  class: "dom_assembly"
};
const _hoisted_53 = {
  class: "bodr_b"
};
const _hoisted_54 = {
  class: "dom_assembly"
};
const _hoisted_55 = {
  class: "bodr_b"
};
const _hoisted_56 = {
  class: "dom_assembly"
};
const _hoisted_57 = {
  key: 9,
  class: "form_dom"
};
const _hoisted_58 = {
  class: "dom_assembly dom_assembly_more"
};
const _hoisted_59 = {
  class: "option_more"
};
const _hoisted_60 = {
  key: 0,
  src: "https://www.mimodental.com/assets/imgData/img/questionnaire/t_jt.png",
  style: {
    "margin-top": "20px"
  },
  alt: ""
};
const _hoisted_61 = {
  key: 0,
  class: "option_more_form"
};
const _hoisted_62 = {
  class: "bodr_b"
};
const _hoisted_63 = {
  class: "dom_assembly"
};
const _hoisted_64 = {
  class: "bodr_b"
};
const _hoisted_65 = {
  class: "dom_assembly"
};
const _hoisted_66 = {
  key: 10,
  class: "form_dom"
};
const _hoisted_67 = {
  class: "dom_assembly dom_assembly_more"
};
const _hoisted_68 = {
  class: "option_more"
};
const _hoisted_69 = {
  key: 0,
  src: "https://www.mimodental.com/assets/imgData/img/questionnaire/t_jt.png",
  style: {
    "margin-top": "20px"
  },
  alt: ""
};
const _hoisted_70 = {
  key: 0,
  class: "option_more_form"
};
const _hoisted_71 = {
  class: "bodr_b"
};
const _hoisted_72 = {
  class: "dom_assembly"
};
const _hoisted_73 = {
  key: 11,
  class: "form_dom"
};
const _hoisted_74 = {
  class: "dom_assembly"
};
const _hoisted_75 = {
  key: 12,
  class: "form_dom"
};
const _hoisted_76 = {
  class: "dom_assembly"
};
const _hoisted_77 = {
  key: 13,
  class: "form_dom"
};
const _hoisted_78 = {
  class: "dom_assembly Diseases_assembly"
};
const _hoisted_79 = {
  class: "term"
};
const _hoisted_80 = {
  class: "btn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_cascader = _resolveComponent("van-cascader");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_van_date_picker = _resolveComponent("van-date-picker");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/fh.png",
    alt: "",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.fh && $setup.fh(...args))
  }), _cache[57] || (_cache[57] = _createElementVNode("span", null, "填写资料", -1))]), _cache[89] || (_cache[89] = _createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/img/questionnaire/logo.png",
    class: "logo",
    alt: ""
  }, null, -1)), _cache[90] || (_cache[90] = _createElementVNode("div", {
    class: "tip"
  }, [_createElementVNode("span", null, [_createTextVNode("温馨提示：（"), _createElementVNode("span", {
    style: {
      "color": "red"
    }
  }, "*"), _createTextVNode("是必选项）")]), _createElementVNode("span", null, "欢迎您选择米檬口腔！为了能为您提供高质量的服务，请认真填写下表，所有个人资料我们都将为您严格保密。/ Welcome to Mimo Dental Clinic, in order to provide the most holistic dental care treatments for your family, please fill out our registration form. For all personal data will be kept strictly confidential for you.")], -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[58] || (_cache[58] = _createElementVNode("span", null, "个人基本信息", -1)), $setup.form_state.nr1 ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: "https://www.mimodental.com/assets/imgData/img/questionnaire/jt.png",
    onClick: _cache[1] || (_cache[1] = $event => $setup.form_state.nr1 = !$setup.form_state.nr1),
    alt: ""
  })) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    src: "https://www.mimodental.com/assets/imgData/img/questionnaire/jt_shang.png",
    onClick: _cache[2] || (_cache[2] = $event => $setup.form_state.nr1 = !$setup.form_state.nr1),
    alt: ""
  }))]), _createElementVNode("div", {
    class: "form_nr",
    style: _normalizeStyle('padding:' + ($setup.form_state.nr1 ? '50px' : '25px'))
  }, [$setup.form_state.nr1 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_cache[59] || (_cache[59] = _createElementVNode("div", {
    class: "dom_title"
  }, [_createElementVNode("span", {
    style: {
      "color": "red"
    }
  }, "*"), _createTextVNode("姓名 Name ")], -1)), _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "请输入姓名",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.push_data.name = $event)
  }, null, 512), [[_vModelText, $setup.push_data.name]])])])) : _createCommentVNode("", true), $setup.form_state.nr1 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_cache[60] || (_cache[60] = _createElementVNode("div", {
    class: "dom_title"
  }, [_createElementVNode("span", {
    style: {
      "color": "red"
    }
  }, "*"), _createTextVNode("性别 Gender ")], -1)), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
    class: _normalizeClass(["option", $setup.push_data.sex == 0 ? 'Selected_option' : 'cancellation_option']),
    onClick: _cache[4] || (_cache[4] = $event => $setup.optionClick('sex', 0))
  }, " 男 Male ", 2), _createElementVNode("div", {
    class: _normalizeClass(["option", $setup.push_data.sex == 1 ? 'Selected_option' : 'cancellation_option']),
    onClick: _cache[5] || (_cache[5] = $event => $setup.optionClick('sex', 1))
  }, " 女 Female ", 2)])])) : _createCommentVNode("", true), $setup.form_state.nr1 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_cache[61] || (_cache[61] = _createElementVNode("div", {
    class: "dom_title"
  }, [_createElementVNode("span", {
    style: {
      "color": "red"
    }
  }, "*"), _createTextVNode("手机 Mobile ")], -1)), _createElementVNode("div", _hoisted_10, [$setup.user_info.phone ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($setup.user_info.phone), 1)) : _withDirectives((_openBlock(), _createElementBlock("input", {
    key: 1,
    type: "text",
    placeholder: "请输入手机",
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $setup.push_data.phone = $event)
  }, null, 512)), [[_vModelText, $setup.push_data.phone]])])])) : _createCommentVNode("", true), $setup.form_state.nr1 && !$setup.user_info.phone ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_cache[62] || (_cache[62] = _createElementVNode("div", {
    class: "dom_title"
  }, [_createElementVNode("span", {
    style: {
      "color": "red"
    }
  }, "*"), _createTextVNode("验证码 Code ")], -1)), _createElementVNode("div", _hoisted_13, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "请输入验证码",
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $setup.push_data.captcha = $event),
    maxlength: "4",
    style: {
      "width": "30rem"
    }
  }, null, 512), [[_vModelText, $setup.push_data.captcha]]), _createElementVNode("div", {
    class: "get_code",
    onClick: _cache[8] || (_cache[8] = (...args) => $setup.get_code && $setup.get_code(...args))
  }, _toDisplayString($setup.getText), 1)])])) : _createCommentVNode("", true), $setup.form_state.nr1 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_cache[63] || (_cache[63] = _createElementVNode("div", {
    class: "dom_title"
  }, [_createElementVNode("span", {
    style: {
      "color": "red"
    }
  }, "*"), _createTextVNode("所在区域 Location ")], -1)), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
    style: _normalizeStyle([{
      "font-size": "40px",
      "padding": "0 20px"
    }, 'color:' + ($setup.push_data.location ? '#000' : '#b2b2b2') + ';']),
    onClick: _cache[9] || (_cache[9] = $event => $setup.qr_show = true)
  }, _toDisplayString($setup.push_data.location ? $setup.push_data.location : '请选择所在区域'), 5), _createVNode(_component_van_popup, {
    show: $setup.qr_show,
    "onUpdate:show": _cache[12] || (_cache[12] = $event => $setup.qr_show = $event),
    round: "",
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cascader, {
      modelValue: _ctx.cascaderValue,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _ctx.cascaderValue = $event),
      title: "请选择所在地区",
      options: $setup.options,
      onClose: _cache[11] || (_cache[11] = $event => $setup.qr_show = false),
      onFinish: $setup.onFinish
    }, null, 8, ["modelValue", "options", "onFinish"])]),
    _: 1
  }, 8, ["show"]), _createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/img/questionnaire/dz.png",
    onClick: _cache[13] || (_cache[13] = $event => $setup.qr_show = true),
    alt: ""
  })])])) : _createCommentVNode("", true), $setup.form_state.nr1 && !$setup.user_info.phone ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_cache[64] || (_cache[64] = _createElementVNode("div", {
    class: "dom_title"
  }, [_createElementVNode("span", {
    style: {
      "color": "red"
    }
  }, "*"), _createTextVNode("了解渠道？ Understanding channels ")], -1)), _createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.channel, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["option", $setup.push_data.know_source == item.dictValue ? 'Selected_option' : 'cancellation_option']),
      key: index,
      onClick: $event => $setup.optionClick('know_source', item.dictValue)
    }, _toDisplayString(item.dictLabel), 11, _hoisted_18);
  }), 128))]), $setup.push_data.know_source == 'other' ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "请输入其他了解渠道",
    "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $setup.other_channel = $event)
  }, null, 512), [[_vModelText, $setup.other_channel]])])])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 4)]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_cache[65] || (_cache[65] = _createElementVNode("span", null, "健康状况", -1)), $setup.form_state.nr2 ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: "https://www.mimodental.com/assets/imgData/img/questionnaire/jt.png",
    onClick: _cache[15] || (_cache[15] = $event => $setup.form_state.nr2 = !$setup.form_state.nr2),
    alt: ""
  })) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    src: "https://www.mimodental.com/assets/imgData/img/questionnaire/jt_shang.png",
    onClick: _cache[16] || (_cache[16] = $event => $setup.form_state.nr2 = !$setup.form_state.nr2),
    alt: ""
  }))]), _createElementVNode("div", {
    class: "form_nr",
    style: _normalizeStyle('padding:' + ($setup.form_state.nr2 ? '50px' : '25px'))
  }, [$setup.form_state.nr2 ? (_openBlock(), _createElementBlock("div", _hoisted_24, " 请回答下列问题，以便医生为您做出最妥善的治疗 ")) : _createCommentVNode("", true), $setup.form_state.nr2 ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_cache[66] || (_cache[66] = _createElementVNode("div", {
    class: "dom_title"
  }, " 出生日期 Date of Birth ", -1)), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", {
    style: _normalizeStyle([{
      "font-size": "40px",
      "padding": "0 20px"
    }, 'color:' + ($setup.push_data.birthday ? '#000' : '#b2b2b2') + ';']),
    onClick: _cache[17] || (_cache[17] = $event => $setup.rl_show = true)
  }, _toDisplayString($setup.push_data.birthday ? $setup.push_data.birthday : '请选择出生日期'), 5), _createVNode(_component_van_popup, {
    show: $setup.rl_show,
    "onUpdate:show": _cache[19] || (_cache[19] = $event => $setup.rl_show = $event),
    round: "",
    position: "bottom"
  }, {
    default: _withCtx(() => [$setup.rl_show ? (_openBlock(), _createBlock(_component_van_date_picker, {
      key: 0,
      modelValue: $setup.time_data,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $setup.time_data = $event),
      title: "选择日期",
      "min-date": $setup.min_date,
      "max-date": $setup.max_date,
      formatter: $setup.formatter,
      "columns-type": $setup.columnsType,
      "option-height": "8.5rem",
      onCancel: $setup.tiem_cancel,
      onConfirm: $setup.time_confirm
    }, null, 8, ["modelValue", "min-date", "max-date", "formatter", "columns-type", "onCancel", "onConfirm"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["show"]), _createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/img/questionnaire/rl.png",
    onClick: _cache[20] || (_cache[20] = $event => $setup.rl_show = true),
    alt: ""
  })])])) : _createCommentVNode("", true), $setup.form_state.nr2 ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_cache[67] || (_cache[67] = _createElementVNode("div", {
    class: "dom_title"
  }, " 电子邮箱 E-mail ", -1)), _createElementVNode("div", _hoisted_28, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "请输入电子邮箱",
    "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $setup.push_data.email = $event)
  }, null, 512), [[_vModelText, $setup.push_data.email]])])])) : _createCommentVNode("", true), $setup.form_state.nr2 ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_cache[68] || (_cache[68] = _createElementVNode("div", {
    class: "dom_title"
  }, " 紧急联系人 Emergency Contact Person ", -1)), _createElementVNode("div", _hoisted_30, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "请输入紧急联系人",
    "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => $setup.push_data.contact = $event)
  }, null, 512), [[_vModelText, $setup.push_data.contact]])])])) : _createCommentVNode("", true), $setup.form_state.nr2 ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_cache[69] || (_cache[69] = _createElementVNode("div", {
    class: "dom_title"
  }, " 联系人电话 Emergency Contact Number ", -1)), _createElementVNode("div", _hoisted_32, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "请输入紧急联系人电话",
    "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => $setup.push_data.contactPhone = $event)
  }, null, 512), [[_vModelText, $setup.push_data.contactPhone]])])])) : _createCommentVNode("", true), $setup.form_state.nr2 ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_cache[70] || (_cache[70] = _createElementVNode("div", {
    class: "dom_title"
  }, " 工作单位 Work Unit ", -1)), _createElementVNode("div", _hoisted_34, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "请输入工作单位",
    "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => $setup.push_data.workUnit = $event)
  }, null, 512), [[_vModelText, $setup.push_data.workUnit]])])])) : _createCommentVNode("", true), $setup.form_state.nr2 ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_cache[71] || (_cache[71] = _createElementVNode("div", {
    class: "dom_title"
  }, " 身份证 ID Number ", -1)), _createElementVNode("div", _hoisted_36, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "请输入身份证",
    "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => $setup.push_data.identityCard = $event)
  }, null, 512), [[_vModelText, $setup.push_data.identityCard]])])])) : _createCommentVNode("", true), $setup.form_state.nr2 ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_cache[74] || (_cache[74] = _createElementVNode("div", {
    class: "dom_title"
  }, " 是否朋友介绍 Introduced by Friend ", -1)), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createElementVNode("div", {
    class: _normalizeClass(["option", $setup.auxiliary.byFrienda == 1 ? 'Selected_option' : 'cancellation_option']),
    onClick: _cache[26] || (_cache[26] = $event => $setup.auxiliaryClick('byFrienda', 1))
  }, " 是 Yes ", 2), $setup.auxiliary.byFrienda == 1 ? (_openBlock(), _createElementBlock("img", _hoisted_40)) : _createCommentVNode("", true)]), _createElementVNode("div", {
    style: _normalizeStyle('height:' + ($setup.auxiliary.byFrienda == 1 ? '124px;' : ''))
  }, [_createElementVNode("div", {
    class: _normalizeClass(["option", $setup.auxiliary.byFrienda == 0 ? 'Selected_option' : 'cancellation_option']),
    onClick: _cache[27] || (_cache[27] = $event => $setup.auxiliaryClick('byFrienda', 0))
  }, " 否 No ", 2)], 4)]), $setup.auxiliary.byFrienda == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_cache[72] || (_cache[72] = _createElementVNode("div", {
    class: "dom_title"
  }, " 介绍人姓名 Refereed by ", -1)), _createElementVNode("div", _hoisted_43, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "请输入介绍人姓名",
    "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => $setup.push_data.refereedBy = $event)
  }, null, 512), [[_vModelText, $setup.push_data.refereedBy]])])]), _createElementVNode("div", _hoisted_44, [_cache[73] || (_cache[73] = _createElementVNode("div", {
    class: "dom_title"
  }, " 联系电话 Tel ", -1)), _createElementVNode("div", _hoisted_45, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "请输入联系电话",
    "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => $setup.push_data.refereedPhone = $event)
  }, null, 512), [[_vModelText, $setup.push_data.refereedPhone]])])])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $setup.form_state.nr2 ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_cache[78] || (_cache[78] = _createElementVNode("div", {
    class: "dom_title"
  }, " 是否有过敏史 Allergic History ", -1)), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createElementVNode("div", {
    class: _normalizeClass(["option", $setup.auxiliary.IsAllergy == 1 ? 'Selected_option' : 'cancellation_option']),
    onClick: _cache[30] || (_cache[30] = $event => $setup.auxiliaryClick('IsAllergy', 1))
  }, " 是 Yes ", 2), $setup.auxiliary.IsAllergy == 1 ? (_openBlock(), _createElementBlock("img", _hoisted_49)) : _createCommentVNode("", true)]), _createElementVNode("div", {
    style: _normalizeStyle('height:' + ($setup.auxiliary.IsAllergy == 1 ? '124px;' : ''))
  }, [_createElementVNode("div", {
    class: _normalizeClass(["option", $setup.auxiliary.IsAllergy == 0 ? 'Selected_option' : 'cancellation_option']),
    onClick: _cache[31] || (_cache[31] = $event => $setup.auxiliaryClick('IsAllergy', 0))
  }, " 否 No ", 2)], 4)]), $setup.auxiliary.IsAllergy == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_cache[75] || (_cache[75] = _createElementVNode("div", {
    class: "dom_title"
  }, " 药物 Medicine ", -1)), _createElementVNode("div", _hoisted_52, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "请输入药物",
    "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => $setup.push_data.allergicMedicine = $event)
  }, null, 512), [[_vModelText, $setup.push_data.allergicMedicine]])])]), _createElementVNode("div", _hoisted_53, [_cache[76] || (_cache[76] = _createElementVNode("div", {
    class: "dom_title"
  }, " 食物 Food ", -1)), _createElementVNode("div", _hoisted_54, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "请输入食物",
    "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => $setup.push_data.allergicFood = $event)
  }, null, 512), [[_vModelText, $setup.push_data.allergicFood]])])]), _createElementVNode("div", _hoisted_55, [_cache[77] || (_cache[77] = _createElementVNode("div", {
    class: "dom_title"
  }, " 其他 Others ", -1)), _createElementVNode("div", _hoisted_56, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "请输入其他",
    "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => $setup.push_data.allergicOthers = $event)
  }, null, 512), [[_vModelText, $setup.push_data.allergicOthers]])])])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $setup.form_state.nr2 ? (_openBlock(), _createElementBlock("div", _hoisted_57, [_cache[81] || (_cache[81] = _createElementVNode("div", {
    class: "dom_title"
  }, " 是否服用药物 Are You On Any Medicine ", -1)), _createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_createElementVNode("div", {
    class: _normalizeClass(["option", $setup.auxiliary.Medicine == 1 ? 'Selected_option' : 'cancellation_option']),
    onClick: _cache[35] || (_cache[35] = $event => $setup.auxiliaryClick('Medicine', 1))
  }, " 是 Yes ", 2), $setup.auxiliary.Medicine == 1 ? (_openBlock(), _createElementBlock("img", _hoisted_60)) : _createCommentVNode("", true)]), _createElementVNode("div", {
    style: _normalizeStyle('height:' + ($setup.auxiliary.Medicine == 1 ? '124px;' : ''))
  }, [_createElementVNode("div", {
    class: _normalizeClass(["option", $setup.auxiliary.Medicine == 0 ? 'Selected_option' : 'cancellation_option']),
    onClick: _cache[36] || (_cache[36] = $event => $setup.auxiliaryClick('Medicine', 0))
  }, " 否 No ", 2)], 4)]), $setup.auxiliary.Medicine == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_cache[79] || (_cache[79] = _createElementVNode("div", {
    class: "dom_title"
  }, " 药物名称 Name Of Medicine ", -1)), _createElementVNode("div", _hoisted_63, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "请输入药物名称",
    "onUpdate:modelValue": _cache[37] || (_cache[37] = $event => $setup.push_data.medicineNow = $event)
  }, null, 512), [[_vModelText, $setup.push_data.medicineNow]])])]), _createElementVNode("div", _hoisted_64, [_cache[80] || (_cache[80] = _createElementVNode("div", {
    class: "dom_title"
  }, " 原因 For What Reason ", -1)), _createElementVNode("div", _hoisted_65, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "请输入原因",
    "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => $setup.push_data.medicineReason = $event)
  }, null, 512), [[_vModelText, $setup.push_data.medicineReason]])])])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $setup.form_state.nr2 ? (_openBlock(), _createElementBlock("div", _hoisted_66, [_cache[83] || (_cache[83] = _createElementVNode("div", {
    class: "dom_title"
  }, " 是否曾对麻醉类药物出现不良反应 Any Side Effect To Dental Anesthetic ", -1)), _createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_createElementVNode("div", {
    class: _normalizeClass(["option", $setup.auxiliary.Anesthetic == 1 ? 'Selected_option' : 'cancellation_option']),
    onClick: _cache[39] || (_cache[39] = $event => $setup.auxiliaryClick('Anesthetic', 1))
  }, " 是 Yes ", 2), $setup.auxiliary.Anesthetic == 1 ? (_openBlock(), _createElementBlock("img", _hoisted_69)) : _createCommentVNode("", true)]), _createElementVNode("div", {
    style: _normalizeStyle('height:' + ($setup.auxiliary.Anesthetic == 1 ? '124px;' : ''))
  }, [_createElementVNode("div", {
    class: _normalizeClass(["option", $setup.auxiliary.Anesthetic == 0 ? 'Selected_option' : 'cancellation_option']),
    onClick: _cache[40] || (_cache[40] = $event => $setup.auxiliaryClick('Anesthetic', 0))
  }, " 否 No ", 2)], 4)]), $setup.auxiliary.Anesthetic == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_70, [_createElementVNode("div", _hoisted_71, [_cache[82] || (_cache[82] = _createElementVNode("div", {
    class: "dom_title"
  }, " 麻药名称 Drug name ", -1)), _createElementVNode("div", _hoisted_72, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "请输入麻药名称",
    "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => $setup.push_data.adverseAnesthetic = $event)
  }, null, 512), [[_vModelText, $setup.push_data.adverseAnesthetic]])])])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $setup.form_state.nr2 ? (_openBlock(), _createElementBlock("div", _hoisted_73, [_cache[84] || (_cache[84] = _createElementVNode("div", {
    class: "dom_title"
  }, " 是否在妊娠期？ Are You Pregnant ", -1)), _createElementVNode("div", _hoisted_74, [_createElementVNode("div", {
    class: _normalizeClass(["option", $setup.push_data.isPregnant == 1 ? 'Selected_option' : 'cancellation_option']),
    onClick: _cache[42] || (_cache[42] = $event => $setup.optionClick('isPregnant', 1))
  }, " 是 Yes ", 2), _createElementVNode("div", {
    class: _normalizeClass(["option", $setup.push_data.isPregnant == 0 ? 'Selected_option' : 'cancellation_option']),
    onClick: _cache[43] || (_cache[43] = $event => $setup.optionClick('isPregnant', 0))
  }, " 否 No ", 2)])])) : _createCommentVNode("", true), $setup.form_state.nr2 ? (_openBlock(), _createElementBlock("div", _hoisted_75, [_cache[85] || (_cache[85] = _createElementVNode("div", {
    class: "dom_title"
  }, " 是否有种植体？ Anylmplants ", -1)), _createElementVNode("div", _hoisted_76, [_createElementVNode("div", {
    class: _normalizeClass(["option", $setup.push_data.anyImplants == 1 ? 'Selected_option' : 'cancellation_option']),
    onClick: _cache[44] || (_cache[44] = $event => $setup.optionClick('anyImplants', 1))
  }, " 是 Yes ", 2), _createElementVNode("div", {
    class: _normalizeClass(["option", $setup.push_data.anyImplants == 0 ? 'Selected_option' : 'cancellation_option']),
    onClick: _cache[45] || (_cache[45] = $event => $setup.optionClick('anyImplants', 0))
  }, " 否 No ", 2)])])) : _createCommentVNode("", true), $setup.form_state.nr2 ? (_openBlock(), _createElementBlock("div", _hoisted_77, [_cache[86] || (_cache[86] = _createElementVNode("div", {
    class: "dom_title"
  }, " 是否患有下列疾病？ Other Diseases ", -1)), _createElementVNode("div", _hoisted_78, [_createElementVNode("div", {
    class: _normalizeClass(["option", $setup.push_data.otherDiseases == 0 ? 'Selected_option' : 'cancellation_option']),
    onClick: _cache[46] || (_cache[46] = $event => $setup.optionClick('otherDiseases', 0))
  }, " 高血压 Hypertension ", 2), _createElementVNode("div", {
    class: _normalizeClass(["option", $setup.push_data.otherDiseases == 1 ? 'Selected_option' : 'cancellation_option']),
    onClick: _cache[47] || (_cache[47] = $event => $setup.optionClick('otherDiseases', 1))
  }, " 糖尿病 Diabetes ", 2), _createElementVNode("div", {
    class: _normalizeClass(["option", $setup.push_data.otherDiseases == 2 ? 'Selected_option' : 'cancellation_option']),
    onClick: _cache[48] || (_cache[48] = $event => $setup.optionClick('otherDiseases', 2))
  }, " 心脏病史 Heart Disease ", 2), _createElementVNode("div", {
    class: _normalizeClass(["option", $setup.push_data.otherDiseases == 3 ? 'Selected_option' : 'cancellation_option']),
    onClick: _cache[49] || (_cache[49] = $event => $setup.optionClick('otherDiseases', 3))
  }, " 肝炎 Hypatitis ", 2), _createElementVNode("div", {
    class: _normalizeClass(["option", $setup.push_data.otherDiseases == 4 ? 'Selected_option' : 'cancellation_option']),
    onClick: _cache[50] || (_cache[50] = $event => $setup.optionClick('otherDiseases', 4))
  }, " 血液病 Hematopathy ", 2), _createElementVNode("div", {
    class: _normalizeClass(["option", $setup.push_data.otherDiseases == 5 ? 'Selected_option' : 'cancellation_option']),
    onClick: _cache[51] || (_cache[51] = $event => $setup.optionClick('otherDiseases', 5))
  }, " 传染病 Infectious diseases ", 2), _createElementVNode("div", {
    class: _normalizeClass(["option", $setup.push_data.otherDiseases == 6 ? 'Selected_option' : 'cancellation_option']),
    onClick: _cache[52] || (_cache[52] = $event => $setup.optionClick('otherDiseases', 6))
  }, " 无 No ", 2), _createElementVNode("div", {
    class: _normalizeClass(["option", $setup.push_data.otherDiseases == 7 ? 'Selected_option' : 'cancellation_option']),
    onClick: _cache[53] || (_cache[53] = $event => $setup.optionClick('otherDiseases', 7))
  }, " 其他 Others ", 2)])])) : _createCommentVNode("", true)], 4)]), _createElementVNode("div", _hoisted_79, [_createElementVNode("div", _hoisted_80, [!$setup.isAccept ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    style: {
      "margin-right": "1rem",
      "vertical-align": "middle",
      "width": "3rem",
      "height": "3rem"
    },
    onClick: _cache[54] || (_cache[54] = $event => $setup.isAccept = !$setup.isAccept),
    src: "https://www.mimodental.com/assets/imgData/img/questionnaire/wqr.png"
  })) : _createCommentVNode("", true), $setup.isAccept ? (_openBlock(), _createElementBlock("img", {
    key: 1,
    style: {
      "margin-right": "1rem",
      "vertical-align": "middle",
      "width": "3rem",
      "height": "3rem"
    },
    onClick: _cache[55] || (_cache[55] = $event => $setup.isAccept = !$setup.isAccept),
    src: "https://www.mimodental.com/assets/imgData/img/questionnaire/qr.png"
  })) : _createCommentVNode("", true)]), _cache[87] || (_cache[87] = _createElementVNode("div", null, [_createTextVNode(" 我已如实在上述声明中叙述了我的所有疾病、手术、过敏史 "), _createElementVNode("div", null, " I herebypromise that I do not have any other diseases，operations or allergies that I have not declared above. ")], -1))]), _createElementVNode("div", {
    class: "push_data_btn",
    onClick: _cache[56] || (_cache[56] = (...args) => $setup.push_data_click && $setup.push_data_click(...args))
  }, _cache[88] || (_cache[88] = [_createElementVNode("span", null, "提交", -1)]))]);
}